import { useState } from "react";
import { format } from "date-fns";
import { useApi } from "providers/ApiProvider";
import { useSnackbarContext } from "~/SnackbarProvider_v2";
import { CertificateStatus } from "type/certificateType";
import Icon from "~/components/Icon";
import { Button } from "~/components/Button";
import CertificateInput from "~/components/certificate/CertificateInput";
import { NormalModal } from "~/modals/common/NormalModal";
import { Box, Stack } from "./CertificateConfirmModal.styled";

interface CertificateConfirmModalProps {
  certificateStatus: CertificateStatus;
  certificate: any;
  description?: any;
  onClose: ({ value, password }: { value: boolean; password?: string }) => void;
}

const CertificateConfirmModal = ({
  certificateStatus,
  certificate,
  description,
  onClose,
}: CertificateConfirmModalProps) => {
  const { certificateApi } = useApi();
  const snackbar = useSnackbarContext();
  const [password, setPassword] = useState<string>("");
  const colorClassName = certificateStatus === "NEED_RENEW" ? "red" : "";

  const handleClickSave = async () => {
    if (!password) {
      return snackbar.alert("인증서 암호를 입력해 주세요.");
    }

    try {
      const payload = {
        externalCertificateId: certificate.externalCertificateId,
        password,
      };
      await certificateApi.validationCertificateSign(payload);
      onClose({ value: true, password });
    } catch (e: any) {
      snackbar.alert(e.response.data.description);
    }
  };

  return (
    <NormalModal
      title="전자서명"
      open={true}
      onClose={() => onClose({ value: false })}
      footer={
        <Stack flexDirection="row" gap="4px">
          <Button
            styled="outline"
            onClick={() => onClose({ value: false })}
            color="mix"
          >
            취소
          </Button>
          <Button onClick={handleClickSave}>확인</Button>
        </Stack>
      }
    >
      <Box className="modal-container">
        {description && description}
        <Box className="certificate-view-container">
          <Stack flexDirection="row" alignItems="center">
            <Icon variant="certificate" />
          </Stack>
          <Stack justifyContent="center" gap="10px">
            <Box className="certificate-name">{certificate.subjectDn}</Box>
            <Box className="expiration-date">
              <Box className={`label ${colorClassName}`}>만료일</Box>
              <Box className="date">
                <Stack flexDirection="row" gap="4px">
                  <span className={`${colorClassName}`}>
                    {format(new Date(certificate.endDate), "yyyy-MM-dd")}
                  </span>
                  {certificateStatus === "NEED_RENEW" && (
                    <Box className="badge red">갱신필요</Box>
                  )}
                </Stack>
              </Box>
            </Box>
          </Stack>
        </Box>
        <CertificateInput password={password} setPassword={setPassword} />
      </Box>
    </NormalModal>
  );
};

export default CertificateConfirmModal;
